import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { HlmSidebarWrapper, HlmSidebarInset } from '@pagai-fe/ui';

import { AppSidebarComponent } from '../../components/app-sidebar/app-sidebar.component';

/**
 * Layout component that wraps content with the sidebar navigation
 * Uses Spartan UI sidebar wrapper for proper spacing and layout
 */
@Component({
  selector: 'app-sidebar-layout',
  standalone: true,
  imports: [RouterOutlet, HlmSidebarWrapper, HlmSidebarInset, AppSidebarComponent],
  templateUrl: './sidebar-layout.component.html',
})
export class SidebarLayoutComponent {}
